"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortIoConfigOutSerializer = void 0;
exports.PortIoConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=portIoConfigOut.js.map